import React from 'react';

interface CookieBannerProps {
  onAccept: () => void;
  onReject: () => void;
  onSettings: () => void;
  onPrivacyPolicyClick: () => void;
}

const CookieBanner: React.FC<CookieBannerProps> = ({ onAccept, onReject, onSettings, onPrivacyPolicyClick }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-off-white p-4 shadow-[0_-2px_10px_rgba(0,0,0,0.2)] z-50">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-dark-blue max-w-xl">
          We use cookies to improve your experience. By clicking "Accept all cookies", you agree to the use of cookies for analytics and marketing purposes. For more details, please see our{' '}
          <button onClick={onPrivacyPolicyClick} className="font-semibold text-brand-purple hover:underline">Privacy Policy</button>.
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={onReject}
            className="px-6 py-2 rounded-full border border-brand-purple text-brand-purple bg-white hover:bg-purple-50 transition-colors text-sm font-semibold"
          >
            Reject all
          </button>
          <button
            onClick={onAccept}
            className="px-6 py-2 rounded-full bg-brand-purple text-white hover:bg-purple-700 transition-colors text-sm font-semibold"
          >
            Accept all cookies
          </button>
          <button
            onClick={onSettings}
            className="text-brand-purple hover:underline text-sm font-semibold"
          >
            Cookie settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;